<div class="section">
    <div data-qa-id="locums-rec-certifications-header" class="nova__label">Certifications</div>
    <div data-qa-id="locums-rec-certifications-value">
        <label *ngIf="unitCertifications?.length === 0" data-qa-id="locums-rec-certifications-dash">-</label>
        <div class="jd__section__container" *ngIf="unitCertifications?.length > 0">
            <ng-container *ngFor=" let unitCertification of unitCertifications; let i=index">
                <label [attr.data-qa-id]="'locums-rec-certifications-label-' + i">
                    {{ unitCertification.name  }}
                </label>
                <label class="jd__section__emphasized" [attr.data-qa-id]="'locums-rec-certifications-details-' + i">
                    {{ getUnitCertificationsDetails(unitCertification) }}
                </label>
            </ng-container>
        </div>
    </div>
</div>